import { useEffect, ReactElement } from 'react';
import { trackPage } from '../services/analytics-client';

interface Props {
  children: ReactElement;
}

const Page = ({ children }: Props): ReactElement => {
  /**
   * For handling multiple routes, see next.js docs
   * https://nextjs.org/docs/api-reference/next/router#router-object
   */
  useEffect(() => {
    const currentUrl = `${window.location.host}${window.location.pathname}`;
    trackPage(currentUrl);
  }, []);
  return children;
};

export default Page;
